import React, { useContext } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./View_address_modal.css";
import { Context } from "../../../../utils/context";

const View_address_modal_Images = (props) => {
  const { IMG_URL } = useContext(Context);

  const [previewImage, setPreviewImage] = React.useState(null);
  const [showImageModal, setShowImageModal] = React.useState(false);

  const handleImageClick = (img) => {
    setPreviewImage(img);
    setShowImageModal(true);
  };

  const handleCloseImageModal = () => {
    setShowImageModal(false);
    setPreviewImage(null);
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="View_address_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Payment Proof
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="addp">
            <div className="row">
              <div className="col-4">
                <span>Payment Proof:</span>
              </div>
              <div className="col-8">
                {props?.data?.payment_proof && (
                  <div className="img_holder">
                    {props?.data.payment_proof ? (
                      <img
                        src={`${IMG_URL}${props?.data.payment_proof}`}
                        alt="Image"
                        className="payment_preview_img"
                        style={{
                          width: "100%",
                          height: "200px",
                          aspectRatio: "1/0.5",
                          objectFit: "contain",
                        }}
                        onClick={() =>
                          handleImageClick(IMG_URL + props?.data.payment_proof)
                        }
                      />
                    ) : (
                      "No Image"
                    )}
                  </div>
                )}
              </div>
            </div>
          </p>
          <hr />
          <p className="addp">
            <div className="row">
              <div className="col-4">
                <span>Other Image:</span>
              </div>
              <div className="col-8">
                {props?.data?.other_image && (
                  <div className="img_holder">
                    {props?.data?.other_image ? (
                      <img
                        src={`${IMG_URL}${props?.data.other_image}`}
                        alt="Image"
                        className="payment_preview_img"
                        style={{
                          width: "100%",
                          height: "200px",
                          aspectRatio: "1/0.5",
                          objectFit: "contain",
                        }}
                        onClick={() =>
                          handleImageClick(IMG_URL + props?.data?.other_image)
                        }
                      />
                    ) : (
                      "No Image"
                    )}
                  </div>
                )}
              </div>
            </div>
          </p>

          <p className="addp">
            <span>Delivery Boy Remark:</span>
            {props?.data?.remark || ""}
          </p>
        </Modal.Body>
      </Modal>

      <Modal
        show={showImageModal}
        onHide={handleCloseImageModal}
        centered
        size="xl"
        className="ImagePreviewModal"
      >
        {/*Top Right Close Button */}
        <Modal.Header closeButton />
        <Modal.Body className="text-center">
          {previewImage && (
            <img
              src={previewImage}
              alt="Preview"
              className="full_preview_img"
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default View_address_modal_Images;
